import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { BankCardVO, ContractCreateVO, loan_credit_getCreditInfo_response, loan_order_loanOrder_response, loan_order_trialCalculation_response, userInfo_bankCard_list_response,loan_repayment_repaymentSystemConfig_response,loan_repayment_lastRepaymentDetail_response } from "./apis.type"
import * as apiCreditSale from "./apis"

export const useSubCodeFruitStore = create<{
  // 资金方相关参数
  funderCode: string // 资金方代码
  orderNo: string // 订单编号
  creditQuotaStatus: number // 授信额度状态
  setCreditQuotaStatus:(status:number) => void // 设置授信额度状态
  setOrderNo:(orderNo:string) => void // 设置订单编号
  setFunderInfo: (funderCode: string) => void // 设置资金方信息

  loanCashType: boolean // 是否是现金贷用户，1-是，0-不是
  setLoanCashType: (loanCashType: boolean) => void // 设置是否是现金贷用户

  originQuery: Record<string, string> // 原始查询参数
  setOriginQuery: (originQuery: Record<string, string>) => void // 设置原始查询参数

  creditInfo: loan_credit_getCreditInfo_response | null // 授信情况
  refreshCreditInfo: () => Promise<loan_credit_getCreditInfo_response> // 刷新授信情况

  // 签约时银行卡信息
  bankCardList: userInfo_bankCard_list_response | [] // 银行卡列表
  getBankCardList: () => Promise<userInfo_bankCard_list_response> // 获取银行卡列表
  signBankCard: BankCardVO | null // 签约时银行卡信息
  setSignBankCard: (signBankCard: BankCardVO) => void // 设置签约时银行卡信息

  // 还款试算
  installmentCalculation: loan_order_trialCalculation_response | null // 还款试算
  getInstallmentCalculation: () => Promise<loan_order_trialCalculation_response> // 获取还款试算

  // 贷款订单详情
  loanOrderDetail: loan_order_loanOrder_response | null // 贷款订单详情
  getLoanOrderDetail: () => Promise<loan_order_loanOrder_response> // 获取贷款订单详情

  // // 赊购签约合同（非模版）
  // contractCreateList: ContractCreateVO[] // 赊购签约合同列表
  // setContractCreateList: (contractCreateList: ContractCreateVO[]) => void // 设置赊购签约合同列表

  // 还款系统配置
  repaymentSystemConfig: loan_repayment_repaymentSystemConfig_response | null // 还款系统配置
  getRepaymentSystemConfig: () => Promise<loan_repayment_repaymentSystemConfig_response> // 获取还款系统配置

  // 获取用户最后一条还款记录
  repaymentLastRepaymentDetail: loan_repayment_lastRepaymentDetail_response | null // 用户最后一条还款记录
  getRepaymentLastRepaymentDetail: () => Promise<loan_repayment_lastRepaymentDetail_response> // 获取用户最后一条还款记录
}>()(persist(
  (set, get) => ({
    // 资金方相关参数
    orderNo:'',
    funderCode: '',
    loanCashType: false,
    creditQuotaStatus: 0,
    setCreditQuotaStatus: (status: number) => { 
      set({ creditQuotaStatus: status })
    },
    setOrderNo: (orderNo:string) => {
      set({orderNo})
    },
    setFunderInfo: (funderCode: string) => {
      set({ funderCode })
    },
    setLoanCashType: (loanCashType: boolean) => { 
      set({ loanCashType })
    },
    originQuery: {},
    setOriginQuery: (originQuery: Record<string, string>) => {
      // 设置原始数据时清空所有状态重新初始化
      set({ 
        originQuery,
        creditInfo: null,
        bankCardList: [],
        signBankCard: null,
        installmentCalculation: null,
        loanOrderDetail: null,
      })
    },

    creditInfo: null,
    refreshCreditInfo: async () => {
      const creditInfo = await apiCreditSale.loan_credit_getCreditInfo()
      set({
        creditInfo: creditInfo
      })
      return creditInfo
    },

    bankCardList: [],
    getBankCardList: async () => {
      const bankCardList = await apiCreditSale.userInfo_bankCard_list()
      set({ bankCardList })
      const firstMatchBankCard = bankCardList.find(item => (item.bindStatus === 2 && item.hasBindExternalType)) // 已有已绑定还款银行卡
      if (firstMatchBankCard && !get().signBankCard) {
        get().setSignBankCard(firstMatchBankCard)
      }
      return bankCardList
    },
    signBankCard: null,
    setSignBankCard: (signBankCard: BankCardVO) => {
      set({ signBankCard })
    },

    installmentCalculation: null,
    getInstallmentCalculation: async () => {
      const installmentCalculation = await apiCreditSale.loan_order_trialCalculation({
        orderNo: get().originQuery.orderId
      })
      set({ installmentCalculation })
      return installmentCalculation
    },

    loanOrderDetail: null,
    getLoanOrderDetail: async () => {
      const loanOrderDetail = await apiCreditSale.loan_order_loanOrder({
        orderNo: get().originQuery.orderId
      })
      set({ loanOrderDetail })
      return loanOrderDetail
    },

    // // 赊购签约合同（非模版）
    // contractCreateList: [],
    // setContractCreateList: (contractCreateList) => {
    //   set({ contractCreateList })
    // },

    repaymentSystemConfig: null,
    getRepaymentSystemConfig: async () => {
      const repaymentSystemConfig = await apiCreditSale.loan_repayment_repaymentSystemConfig()
      set({ repaymentSystemConfig })
      return repaymentSystemConfig
    },

    // 获取用户最后一条还款记录
    repaymentLastRepaymentDetail: null,
    getRepaymentLastRepaymentDetail: async () => {
      const repaymentLastRepaymentDetail = await apiCreditSale.loan_repayment_lastRepaymentDetail()
      set({ repaymentLastRepaymentDetail })
      return repaymentLastRepaymentDetail
    },
  }),
  {
    name: 'subCodeFruit-storage', // unique name for localStorage key
  }
))